import {
  breakpoints as defaultBreakPoints,
  desktopScreenType,
  mobileScreenType,
  tabletScreenType,
  MAX_WIDTH,
  SIZES,
  largeScreenMinWidth,
} from "./style";

export const GetScreenType = ({ breakpoints = defaultBreakPoints, defaultDevice = "" } = {}) => {
  const { md, lg } = breakpoints;

  const { innerWidth } = typeof window !== "undefined" && window;
  if (innerWidth) {
    if (innerWidth >= lg) {
      return desktopScreenType;
    }
    if (innerWidth < lg && innerWidth >= md) {
      return tabletScreenType;
    }
    return mobileScreenType;
  }
  // default screen type as desktop for SSR
  return defaultDevice || desktopScreenType;
};

export const getIsLargeScreen = () => {
  const { innerWidth } = typeof window !== "undefined" && window;
  if (innerWidth) {
    return innerWidth >= largeScreenMinWidth;
  }
  return false;
};

export const getComputedSizes = (sizeObj = {}) =>
  SIZES.reduce((currentSizes, currentScreenType) => {
    const size = sizeObj[currentScreenType];
    if (size) {
      const maxWidth = MAX_WIDTH[currentScreenType];
      const widthSection = maxWidth ? `(max-width: ${maxWidth})` : "";
      currentSizes.push(`${widthSection} ${size}`);
    }
    return currentSizes;
  }, []).join(", ");

export const isMobileDevice = GetScreenType() === mobileScreenType;

export const GetDeviceType = () => {
  const userAgent = window?.navigator?.userAgent.toLowerCase();
  if (
    (userAgent.includes("windows nt") && !userAgent.includes("mobile")) ||
    userAgent.includes("macintosh") ||
    (userAgent.includes("linux") && !userAgent.includes("android"))
  ) {
    return "desktop";
  } else if (
    userAgent.includes("ipad") ||
    (userAgent.includes("macintosh") && userAgent.includes("ipad")) ||
    (userAgent.includes("android") && !userAgent.includes("mobile")) ||
    (userAgent.includes("windows nt") && !userAgent.includes("mobile"))
  ) {
    return "tablet";
  } else {
    return "mobile";
  }
};
